import { render, staticRenderFns } from "./messageTitle.vue?vue&type=template&id=30c5ec3a&"
import script from "./messageTitle.vue?vue&type=script&lang=js&"
export * from "./messageTitle.vue?vue&type=script&lang=js&"
import style0 from "./messageTitle.vue?vue&type=style&index=0&id=30c5ec3a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports